"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.defaultProps = exports.default = exports.LoaderGhostBase = void 0;
require("./LoaderGhostBase.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const LoaderGhostBase = props => {
  const {
    variant = defaultProps.variant,
    className,
    ...rest
  } = props;
  const componentClassName = (0, _classnames.default)('pal-c-LoaderGhostBase', `pal-c-LoaderGhostBase--${variant}`, className);
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: componentClassName,
    "aria-hidden": "true"
  }, rest));
};

/**
 * Property type definitions
 * @typedef LoaderGhostBaseProps
 * @type {object}
 * @property {string} variant - Determines the shape of the ghost loader (default, pill, circle).
 * @property {string} className - Optional classes.
 */
exports.LoaderGhostBase = LoaderGhostBase;
const propTypes = exports.propTypes = {
  /**
   * Determines the shape of the ghost loader.
   */
  variant: _propTypes.default.oneOf(['default', 'pill', 'circle']),
  /**
   * Optional classes.
   */
  className: _propTypes.default.string
};

/**
 * Property type definitions
 * @type {object}
 * @property {string} variant - Determines the shape of the ghost loader (default, pill, circle).
 */
const defaultProps = exports.defaultProps = {
  variant: 'default'
};
LoaderGhostBase.propTypes = propTypes;
var _default = exports.default = LoaderGhostBase;